<template>
	<div class='selection-container'>
		<slot></slot>
	</div>
</template>

<script>
	function computeVmIndex(vnodes, element) {
		return vnodes.map(elt => elt.elm).indexOf(element);
	}

	export default {
	    data() {
	        return {

	        }
	    },
	    mounted() {
			const vm = this;
			const options = {
				containers: ['.selection-container'],
				boundaries: ['.selection-container'],

				//--------------------------------------------------------------------
				// ON SELECT
				//--------------------------------------------------------------------

				onSelect(evt) {
					console.log('on select', evt)
					// Check if clicked element is already selected
					let selected = evt.target.classList.contains('selected');

					// Remove class if the user don't pressed the control key or ⌘ key and the
					// current target is already selected
					if (!evt.originalEvent.ctrlKey && !evt.originalEvent.metaKey && !evt.originalEvent.shiftKey) {
						// Remove class from every element which is selected
						evt.selectedElements.forEach((s) => {
							let ele = vm.getUnderlyingVm(s)
							ele.vm.deselect()
						});

						// Clear previous selection
						this.clearSelection();
					}
					let ele = vm.getUnderlyingVm(evt.target)

					if (!selected) {

						// Select element
						ele.vm.select()
						selected = evt.target.classList.contains('selected');
						const elementIndexes = evt.selectedElements.map(e => vm.getUnderlyingVm(e).index)
						// emit whats still selected, plus our newly selected item
						vm.$emit('selected', [ele.index, ...elementIndexes])
						this.keepSelection();
					} else {

						ele.vm.deselect()
						// Unselect element
						let elementIndexes = evt.selectedElements.map(e => vm.getUnderlyingVm(e).index)
						elementIndexes.splice(elementIndexes.indexOf(ele.index), 1)
						vm.$emit('selected', elementIndexes)
						this.removeFromSelection(evt.target);
					}
				},

				//--------------------------------------------------------------------
				// ON START
				//--------------------------------------------------------------------

				onStart(evt) {

					// Get elements which has been selected so far
					const selectedElements = evt.selectedElements;

					// Remove class if the user don't pressed the control key or ⌘ key
					if (!evt.originalEvent.ctrlKey && !evt.originalEvent.metaKey && !evt.originalEvent.shiftKey) {

						// Unselect all elements
						selectedElements.forEach((e) => {
							let s = vm.getUnderlyingVm(e)
							s.vm.deselect()
						})

						// Clear previous selection
						this.clearSelection();
					}
				},

				//--------------------------------------------------------------------
				// ON MOVE
				//--------------------------------------------------------------------

				onMove(evt) {
					const selectedElements = evt.selectedElements;
					const removedElements = evt.changedElements.removed;

					selectedElements.forEach((e) => {
						let s = vm.getUnderlyingVm(e)
						s.vm.select()
					});

					removedElements.forEach((e) => {
						let s = vm.getUnderlyingVm(e)
						s.vm.deselect()
					});
				},

				//--------------------------------------------------------------------
				// ON STOP
				//--------------------------------------------------------------------

				onStop(evt) {
					console.log('ON STOP', evt);
					const elementIndexes = evt.selectedElements.map(e => vm.getUnderlyingVm(e).index);
					vm.$emit('selected', elementIndexes);
					this.keepSelection();
				}
			}; // options

			this.$nextTick(() => {
				this._selection = Selection.create(options);
				console.log(this.$slots);
			});
	    },
		methods: {
			getChildrenNodes() {
				const rawNodes = this.$slots.default
				return rawNodes
			},
			getUnderlyingVm(htmlElt) {
				const index = computeVmIndex(this.getChildrenNodes() || [], htmlElt)

				if (index === -1) {
					return null
				}

				const element = this.$slots.default[index];
				const vm = element.componentInstance;
				return { index, element, vm }
			}
		}
	}
</script>

<!-- UNSCOPED -->
<style lang="scss">
    .selection-area {
        background: rgba(black, 0.1);
        border: 1px solid rgba(black, 0.15);
        // z-index: 99;
    }
</style>

<style scoped>
	/*.selection-container {
		width: 50%;
		margin: 20px;
		height: 250px;
		background: grey;
		padding: 8px;
	}*/
</style>